<template>
  <div id="contenedor-registrar-responsables-proyecto">
    <v-skeleton-loader
      v-if="$apollo.queries.funcionarios.loading"
      type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line">
    </v-skeleton-loader>
    <v-list
      v-else
      nav
      dense>
      <template
        v-for="funcionario in listadoFuncionarios">
        <template>
          <v-list-item
            :key="funcionario.id"
            :class="{'grey lighten-4': funcionario.selected}"
            @click="toggleSeleccionarResponsable(funcionario)">
            <v-list-item-avatar>
              <template
                v-if="funcionario.usuario && funcionario.usuario.avatarPublicKey">
                <Avatar
                  tipo="imagen"
                  :img-url="`http://localhost:3001/${funcionario.usuario.avatarPublicKey}`"
                  :size="32">
                </Avatar>
              </template>
              <template
                v-else>
                <Avatar
                  v-if="funcionario.nombre"
                  tipo="nombre"
                  :nombre="funcionario.nombre"
                  :size="32"
                  color="primary"
                  dark>
                </Avatar>
              </template>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="funcionario.nombre"></v-list-item-title>
              <v-list-item-subtitle v-text="funcionario.puesto"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon
                v-if="funcionario.selected"
                color="success">
                mdi-check-bold
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
      </template>
      <v-list-item
        v-if="listadoFuncionarios.length <= 0">
        <v-list-item-content>
          <v-alert
            type="info">
            No se encontraron resultados.
          </v-alert>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import FUNCIONARIOS from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'SeleccionarResponsablesProyecto',
  props: {
    searchText: {
      type: String,
      required: false,
    },
  },
  components: {
    Avatar,
  },
  data() {
    return {
      responsables: [],
    };
  },
  apollo: {
    funcionarios: {
      query: FUNCIONARIOS,
    },
  },
  methods: {
    toggleSeleccionarResponsable(funcionario) {
      const index = this.responsables.findIndex(({ id }) => id === funcionario.id);

      if (index !== -1) {
        this.responsables.splice(index, 1);
      } else {
        this.responsables.push({
          ...funcionario,
        });

        this.$emit('input', this.responsables);
      }
    },
  },
  computed: {
    listadoFuncionarios() {
      if (!this.funcionarios) return [];
      return [...this.funcionarios.map((funcionario) => ({
        ...funcionario,
        selected: this.responsables.some(({ id }) => funcionario.id === id),
      })),
      ].filter(({ nombre }) => {
        if (!this.searchText) return true;

        const expt = new RegExp(this.searchText, 'gi');
        const nombreLimpio = this.$normalizacionTexto(nombre);

        return expt.test(nombre) || expt.test(nombreLimpio);
      });
    },
  },
};
</script>

<style lang="scss">

</style>
